import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Icon, Label, Menu, Segment } from 'semantic-ui-react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import { convertHelpers } from '../../../../global/common/convert';
import { uniqueKey } from '../../../../global/common/keys';
import NoData from '../../../../global/components/alerts/NoData';
import AlphabetMenuWithProvider from '../../../../global/components/menus/AlphabetMenu';
import MenuSidebars from '../../../../global/sidebars/MenuSidebars';
import { SportsDistrictContext } from '../../cnr/contexts/SportsDistrictContext';
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useSchools } from 'projectSpecific/sports/useHelpers/useSchools';

const sidebarType = 'sports'
const _enrollmentIncrement = 100
const _year = 2024

const DistrictSchools = ({ fromDashboard }) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, navigate } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { schoolsByState, district_data } = sportsDistrict_state ?? {}
  const { schools } = district_data ?? {}

  const { getSchools_fromSite, getSchools_paData, districtSchools, districtSchoolsData } = useSchools()


  const [allSchools, setAllSchools] = useState()
  const [allSports, setAllSports] = useState()
  const [alphaChar, setAlphaChar] = useState('A')
  const [enrollementGroups, setEnrollementGroups] = useState()
  const [selectedSchool, setSelectedSchool] = useState()
  const [selectedSchools, setSelectedSchools] = useState()
  const [selectedAlphaSchools, setSelectedAlphaSchools] = useState()
  const [useAlpha, setUseAlpha] = useState()
  const [showDetails, setShowDetails] = useState()

  const _schoolsCombined = useMemo(() => {
    if (!districtSchools) return
    return _.chain([
      ..._.map(schools, (school, key) => ({
        ...school,
        _itemKey: key
      })),
      ...districtSchools,
      ...(districtSchoolsData || [])
    ])
      .groupBy('name')
      .mapValues(items => _.merge({}, ...items))
      .mapKeys(item => item._itemKey)
      .value()
  }, [districtSchools, districtSchoolsData, schools])

  console.log('_schoolsCombined', _schoolsCombined)

  useEffect(() => {
    getSchools_fromSite()
  }, []);

  const updateRanks = (s, schoolProp) => {
    const enrollments = _.sortBy(_.map(s, 'enrollmentTotal')).reverse();
    _.forEach(s, school => {
      const rank = _.indexOf(enrollments, school.enrollmentTotal) + 1;
      _.set(school, schoolProp, rank);
    });
  }

  useEffect(() => {
    if (schoolsByState) {
      const { schools } = schoolsByState ?? {}

      const _schools = _.cloneDeep(schools)
      updateRanks(_schools, 'enrollmentRank')
      convertHelpers.createItemKeys(_schools)

      const allSportNames = _.sortBy(_.uniq(_.flatMap(_schools, school => {
        const sportsForYear = _.get(school, `sportLevels.${_year}`, {});
        return _.keys(sportsForYear);
      })));

      const enroll_total = _.groupBy(_schools, school => Math.floor(school.enrollmentTotal / _enrollmentIncrement) * _enrollmentIncrement);
      const enroll_male = _.groupBy(_schools, school => Math.floor(school.enrollmentMale / _enrollmentIncrement) * _enrollmentIncrement);
      const enroll_female = _.groupBy(_schools, school => Math.floor(school.enrollmentFemale / _enrollmentIncrement) * _enrollmentIncrement);

      setAllSchools(_.sortBy(_schools, 'name'))
      setSelectedSchools(_.sortBy(_schools, 'name'))
      setAllSports(allSportNames)
      setEnrollementGroups({ total: enroll_total, male: enroll_male, female: enroll_female })


      // const uniqueSportNameLevels = _.uniqBy(_.flatMap(schools, school => {
      //   const yearData = _.get(school, 'sportLevels.2024');
      //   if (yearData && _.isObject(yearData)) {
      //     return _.map(yearData, (sportDataSettings, sportName) => ({ sportName, level: sportDataSettings.level }));
      //   }
      //   return [];
      // }), 'sportName');

      // const uniqueLevels = _.uniq(_.flatMap(uniqueSportNameLevels, 'level'));

      // console.log('schools', schools)
      // console.log('allSportNames', allSportNames)
      // console.log('uniqueSportNameLevels', uniqueSportNameLevels)
      // console.log('uniqueLevels', uniqueLevels)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  // sidebar_state 
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, cnn: 'test' }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { currents, sidebar_items, dimmed } = sidebar_state ?? {}
  const { setInit } = sidebar_handlers ?? {}

  const { ms_sports, ms_enrollment } = sidebar_items ?? {}
  const { selected: selected_sports } = ms_sports ?? {}
  const { item: item_sports } = selected_sports ?? {}
  const { selected: selected_enrollment } = ms_enrollment ?? {}
  const { item: item_enrollment } = selected_enrollment ?? {}

  const _showAlpha = item_enrollment === 'Enrollment' && item_sports === 'Sports' ? true : false

  useEffect(() => {
    if (allSports) {
      const _initProps_sports = { sidebarSliderType: sidebarSliderTypes.normal }
      const xxx = ['Sports', ...allSports]
      setInit({ smt: sidebarMenuTypes.one, items: xxx, currents, as: 'sports', ..._initProps_sports, useStartCase: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [allSports]);

  useEffect(() => {
    if (enrollementGroups) {
      const _initProps_limits = { sidebarSliderType: sidebarSliderTypes.normal }
      const enrollmentArrayWithCount = _.map(enrollementGroups.total, (schools, key) => ({
        range: key === '0' ? '0-' + (_enrollmentIncrement - 1) : `${key}-${parseInt(key) + (_enrollmentIncrement - 1)}`,
        count: schools.length,
      }));

      const xxx = ['Enrollment', 'All (' + allSchools.length + ')']

      enrollmentArrayWithCount.forEach(i => {
        xxx.push(i.range + ' (' + i.count + ')')
      })
      setInit({ smt: sidebarMenuTypes.two, items: xxx, currents, as: 'enrollment', ..._initProps_limits })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [enrollementGroups]);

  const updateCurrentList = () => {

    let _schools = allSchools
    let _useAlpha = true

    if (item_enrollment) {
      const selected = item_enrollment.split('-')[0]
      switch (selected) {
        case 'Enrollment':
          break;
        default:
          if (selected.indexOf('All') >= 0) {
            _useAlpha = false
            _schools = _.sortBy(_schools, 'enrollmentTotal').reverse()
          } else {
            _schools = enrollementGroups && enrollementGroups.total ? enrollementGroups.total[selected] : 0
            _schools = _.sortBy(_schools, 'enrollmentTotal').reverse()
            _useAlpha = false
          }
      }
    }

    switch (item_sports) {
      case 'Sports':
        break;
      default:
        _schools = _.filter(_schools, school => _.has(school, `sportLevels.${_year}.${item_sports}`));
        updateRanks(_schools, 'sportRank')
        _useAlpha = false
    }

    setSelectedSchools(_schools)
    setUseAlpha(_useAlpha)

    if (_useAlpha && alphaChar) {
      const _groupedSchools = _.groupBy(_schools, obj => obj.name[0]);
      const _alphaSchools = _groupedSchools[alphaChar]
      setSelectedAlphaSchools(_alphaSchools)
    }

  }

  useEffect(() => {
    if (allSchools) {
      updateCurrentList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [allSchools, item_sports, item_enrollment, alphaChar]);

  // const handleAlphaChange = (alphaItem) => {
  //   const _alphaChar = String.fromCharCode(alphaItem)
  //   setAlphaChar(_alphaChar)
  // }

  // const handleNavigate = (school) => {
  //   const { _itemKey } = school
  //   let sportPath = '/clients/' + pathViews.clients
  //   sportPath += '/events/' + pathViews.events
  //   sportPath += '/organizations/' + pathViews.organizations
  //   sportPath += '/districts/' + pathViews.districts
  //   const schoolPath = sportPath + '/schools/' + _itemKey
  //   console.log('_itemKey', _itemKey)
  //   console.log('schoolPath', schoolPath)
  //   // 35xt3hBkPjiPtOKGzyL0
  //   // N6eFOnMaGSVTi0gl4JHt
  //   navigate(schoolPath)
  // }

  // const schoolLine = (value, icon) => {
  //   if (value) {
  //     return <div><Icon name={icon} />{value}</div>
  //   }
  // }

  // const contactInfo = (contacts) => {
  //   return Object.keys(contacts).map(ck => {
  //     const contact = contacts[ck]
  //     const { firstName, lastName, email } = contact
  //     return <div>
  //       <div><Icon name='user' />{_.startCase(ck)}{':'}</div>
  //       <div>{lastName}{', '}{firstName}</div>
  //       <div>{email}</div>
  //     </div>
  //   })
  // }

  // const fixLastName = (name) => {
  //   const apostropheIndex = name.indexOf("'");
  //   // If apostrophe exists and the next character is a lowercase letter
  //   if (apostropheIndex !== -1 && /[a-z]/.test(name[apostropheIndex + 1])) {
  //     // Capitalize the letter after the apostrophe
  //     const capitalizedLetter = name[apostropheIndex + 1].toUpperCase();
  //     // Replace the original letter with the capitalized one
  //     name = name.substring(0, apostropheIndex + 1) + capitalizedLetter + name.substring(apostropheIndex + 2);
  //   }
  //   return name;
  // }

  // const schoolInfo = (school) => {
  //   const { name, fullName, webSite, phoneNumber, address, schoolKey, district, contacts } = school ?? {}
  //   console.log('sss', _.startCase(address))
  //   return <div className='schools-list'>
  //     <div>{name}</div>
  //     <div>{fullName}</div>
  //     {schoolLine(schoolKey, 'key')}
  //     {schoolLine(district, 'map outline')}
  //     {schoolLine(_.startCase(_.camelCase(address)), 'map marker alternate')}
  //     {schoolLine(phoneNumber, 'phone')}
  //     {schoolLine(webSite, 'globe')}
  //     {contacts && contactInfo(contacts)}
  //   </div>
  // }

  // const lblEnrollment = (school) => <div>
  //   <Label color='black'> <Icon name='users' color='green' /><span>{school.enrollmentTotal}</span><span>{school.enrollmentFemale}</span><span>{school.enrollmentMale}</span></Label>
  // </div>

  const handleShow_details = (item) => setShowDetails(item.name === showDetails?.name ? null : item)

  const fnAlt = (item) => {
    const { name, initials } = item
    const _team = _.find(_schoolsCombined, { name: name })
    const { teams } = _team ?? {}
    const teams_active = _.filter(teams, { active: true })
    const teamCount = _.size(teams_active)
    return <div style={{ display: 'flex', columnGap: '.5em' }}>
      <Label size='mini' color='blue'><Icon name={'users'} />{teamCount}</Label>
      <Label size='mini'>{initials}</Label>
      {/* <Icon color={'blue'} name={'caret right'} onClick={() => handleShow_details(item)} /> */}
    </div>
  }

  const schoolLine = (value, icon) => {
    if (value) {
      return <div><Icon color='blue' name={icon} />{value}</div>
    }
  }

  const fnSub = (item) => {
    if (item?.name !== showDetails?.name) return;
    const { name } = item
    const _team = _.find(_schoolsCombined, { name: name })
    const _team_data = _.find(districtSchoolsData, { name: name })
    const { fullName, address } = _team ?? {}
    const { phoneNumber, webSite, enrollmentFemale, enrollmentMale, enrollmentTotal, contacts } = _team_data ?? {}
    return <div className='sqr-box-sub il' style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
      {schoolLine(address, 'map marker alternate')}
      {schoolLine(phoneNumber, 'phone')}
      {schoolLine(webSite, 'globe')}
      {schoolLine(enrollmentTotal, 'users')}
      {schoolLine(enrollmentMale, 'male')}
      {schoolLine(enrollmentFemale, 'female')}
      {/* {contacts && <div>{content_contacts(contacts)}</div>} */}
    </div>
  }

  const ims = (sz, caption) => <ItemMenuSquares
    columnCount={fromDashboard ? 4 : 2}
    menuItems={sz}
    caption={caption}
    icon={'list'}
    iconItem={'users'}
    fn_altContent={fnAlt}
  // fn_subContentt={fnSub}
  />

  const ims_schools = () => {
    const grouped = _.mapValues(
      _.groupBy(_schoolsCombined, (s) => _.toUpper(_.first(s.name))),
      (group) => _.sortBy(group, 'name')
    );
    const imsz = _.map(
      _.sortBy(_.keys(grouped)),
      (gk) => ims(grouped[gk], gk)
    );
    return <Wrapper
      content={imsz}
      wrapperType={wrapperTypes.padded}
    >
    </Wrapper>
  }

  return _schoolsCombined ? ims_schools() : <NoData altCaption={'Schools'} />

}

export default DistrictSchools